import Vue from 'vue';
import Router from 'vue-router';
import OrderRouter from './module/order';
import remindRouter from './module/remind';
import WalletROuter from './module/wallet';
import Achievement from './module/achievement';
import IncomeRouter from './module/income';
import AuditRouter from './module/audit';
import CustomerRouter from './module/customer';
import TrackRouter from './module/track';

Vue.use(Router);

export const constantRoutes = [{
		path: '/',
		name: 'Index',
		component: () => import('@/views'),
		meta: {
			title: '首页',
			noCache: true
		}
	},
	WalletROuter,
	{
		path: '/entry',
		name: 'Entry',
		component: () => import('@/views/entry'),
		meta: {
			title: '入口页面',
			noCache: true
		}
	},
	{
		path: '/login',
		name: 'Login',
		component: () => import('@/views/login'),
		meta: {
			title: '智伍互联',
			noCache: true
		}
	},
	{
		path: '/proResearch',
		name: 'proResearch',
		component: () => import('@/views/customerManage/customer/proResearch'),
		meta: {
			title: '学员档案(保密)',
			noCache: true
		}
	},
	{
		path: '/finish',
		name: 'finish',
		component: () => import('@/views/customerManage/customer/finish'),
		meta: {
			title: '已提交',
			noCache: true
		}
	},
];

export const asyncRoutes = [
	OrderRouter,
	remindRouter,
	Achievement,
	IncomeRouter,
	AuditRouter,
	CustomerRouter,
	TrackRouter,
	{
		path: '*',
		redirect: '/entry'
	}
];

const createRouter = () => new Router({
	mode: 'history',
	routes: constantRoutes
});

const router = createRouter();


export default router;
